import { captureError } from './sentryHelpers';

export const fetchEvent = async (eventId) => {
  try {
    const response = await fetch(
      "https://y3vayhw2i5bqrm6fpwqz7fzfwe.appsync-api.eu-central-1.amazonaws.com/graphql",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": "da2-vana665eajd6devxupfcoq3o74",
        },
        body: JSON.stringify({
          query: `
            query GetEvent($id: ID!) {
              getEvent(id: $id) {
                  id
                  name {
                    language
                    text
                  }
              }
            }
          `,
          variables: { id: eventId },
        }),
      },
    );
    const result = await response.json();
    return result?.data?.getEvent;
  } catch (error) {
    captureError(error, {
      feature: "authentication",
      operation: "fetch-event-for-booking",
      context: { eventId },
    });
  }
};
